module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentPage === 'admin') ? _c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n    Transfer\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuspendAlert),
      expression: "showSuspendAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v("Choose Reseller "), _c('span', {
    staticClass: "red-600"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newReseller),
      expression: "newReseller"
    }],
    attrs: {
      "options": _vm.filterItems
    },
    domProps: {
      "value": (_vm.newReseller)
    },
    on: {
      "input": function($event) {
        _vm.newReseller = $event
      }
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p')]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        Submit "), _c('span', {
    staticClass: "glyphicon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de3b5d18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/teams/TeamTransfer.vue
// module id = 562
// module chunks = 1